<button
  type="button"
  class="btn btn-sm btn-secondary"
  (click)="onClicked()"
  [title]="(detailsVisible ? buttonLabelHideDetails : buttonLabelShowDetails) | localize"
  data-testId="measurement-details-button"
>
  <i class="fa" [ngClass]="detailsVisible ? 'fa-angle-up' : 'fa-angle-down'"></i>
</button>
